import { render } from "./type_list.vue?vue&type=template&id=f3b02740"
import script from "./type_list.vue?vue&type=script&lang=js"
export * from "./type_list.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__